import { render, staticRenderFns } from "./LandingSectionGallery.vue?vue&type=template&id=78c6a09a&scoped=true&"
import script from "./LandingSectionGallery.vue?vue&type=script&lang=js&"
export * from "./LandingSectionGallery.vue?vue&type=script&lang=js&"
import style0 from "./LandingSectionGallery.vue?vue&type=style&index=0&id=78c6a09a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c6a09a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LandingText: require('/home/circleci/repo/components/landing/elements/LandingText.vue').default,LandingImage: require('/home/circleci/repo/components/landing/elements/LandingImage.vue').default})
